const brand = sessionStorage.getItem('brand');
export const settings = {
  myAccount: 'Moj račun',
  yourProfileAndPasswordSecurity: 'Vaš profil i sigurnost lozinke',
  detailsHeader: 'Detalji',
  passwordHeader: 'Lozinka',
  customAttributeHeader: 'Prilagođene značajke',
  tagsHeader: 'Oznake',
  accessTokenHeader: 'Pristupni token',
  thirdPartyIntegrationsHeader: 'Integracije s trećim stranama',
  appTooltip: {
    TOOLTIP_DETAILS_HEADING: 'Ažurirajte svoj račun profil',
    TOOLTIP_PASSWORD_HEADING: 'Promijenite svoju lozinku',
    TOOLTIP_TAGS_HEADING: 'Upravljajte svojim oznakama',
    TOOLTIP_THIRD_PARTY_HEADING: 'Integracije s trećim stranama',
    TOOLTIP_CHANGE_PASSWORD_TITLE: `Sigurna lozinka pomaže u sigurnosti vašeg ${brand} računa`,
    TOOLTIP_INTEGRATIONS: 'Integracije',
    TOOLTIP_ADD_UPDATE_CUSTOM_ATTRIBUTE: 'Dodajte ili ažurirajte prilagođene značajke',
    TOOLTIP_CUSTOM_ATTRIBUTES: 'Upravljajte svojim prilagođenim značajkama'
  },
  accessToken: {
    accessToken: 'Pristupni token',
    generateYourAccessTokenForUsingPlatformAPIs: 'Generirajte svoj pristupni token za korištenje platformskih API-ja',
    generateApiToken: 'Generirajte API token',
    revokeApiToken: 'Povucite API token',
    regenerateApiToken: 'Regenerirajte API token',
    placeholders: {
      yourApiKey: 'Vaš API ključ'
    }
  },
  details: {
    name: 'Ime',
    emailId: 'ID e-pošte',
    yourPlan: 'Vaš plan',
    messagesPerMonth: 'Poruke po mjesecu',
    daysOfStoragePlan: 'Dani plana pohrane',
    conditionalFeatures: 'Uvjetne značajke',
    upgradeToEnterprisePlanToGetMore: 'Ažurirajte na Enterprise plan za više mogućnosti',
    featuresAndStorageCapacity: 'Značajke i kapacitet pohrane',
    upgradePlan: 'Ažurirajte plan',
    submit: 'Pošalji',
    selectLanguage: 'Odaberite jezik',
    baby: 'Bebe',
    king: 'Kralj',
    conversationsperMonth: 'Razgovori po mjesecu',
    english: 'Engleski',
    hindi: 'Hindski',
    german: 'Njemački',
    french: 'Francuski',
    portuguese: 'Portugalski',
    spanish: 'Španjolski',
    italian: 'Talijanski',
    russian: 'Ruski',
    chatBotBrandName: 'Naziv robota za razgovor',
    placeholders: {
      john: 'John',
      email: 'E-pošta',
      searchLanguage: 'Pretraživanje jezika',
      chatBotBrandName: 'Naziv robota za razgovor',
      brandWebsiteUrl: 'www.yourbrand.com',
      agencyName: 'Lookup Technologies',
      phoneNumber: '9876543210',
      agencySupportEmail: 'support@yourbrand.com',
      agencyContactPersonName: 'Kevin Peterson',
      agencyContactPersonEmailId: 'kevin@yourbrand.com'
    },
    appTooltip: {
      TOOLTIP_NAME: 'Unesite svoje ime profila',
      TOOLTIP_EMAIL_ADDRESS: 'Unesite svoju adresu e-pošte',
    },
    changeEmail: {
      changeLabel: 'Promijeni',
      sendVerificationCodeModal: {
        changeEmail: 'Promijeni e-poštu',
        changeEmailDescription: 'Unesite novu adresu e-pošte koju želite koristiti u budućnosti',
        newEmailLabel: 'Nova adresa e-pošte',
        changeEmailPlaceholder: 'Unesite novu adresu e-pošte',
        sendVerificationCode: 'Pošalji verifikacijski kod'
      },
      verifyEmailModal: {
        verifyEmail: 'Potvrdi e-poštu!',
        verifyDescription: 'Poslali smo verifikacijski kod na vašu registriranu adresu e-pošte.',
        checkSpam: 'Niste primili e-poštu? Provjerite mapu za neželjenu poštu',
        labelText: 'Unesite 4-znamenkasti kod',
        submitText: 'Pošalji',
        resendText: 'Ponovno pošalji kod'
      }
    },
    myAccountDetails: {
      brandDetails: 'Detalji brenda',
      brandName: 'Naziv brenda',
      brandWebsiteUrl: 'URL web stranice brenda',
      brandLogo: 'Logo brenda',
      agencyDetails: 'Detalji agencije',
      agencyName: 'Naziv agencije',
      agencyPhoneNumber: 'Broj telefona agencije',
      agencyEmailId: 'ID e-pošte agencije',
      contactPersonDetails: 'Detalji kontakta',
      contactName: 'Ime kontakta',
      phoneNumber: 'Broj telefona',
      contactEmailId: 'ID e-pošte kontakta',
      updateDetails: 'Ažurirajte detalje',
    },
  },
  customAttribute: {
    addAttribute: 'Dodaj značajku',
    discard: 'Odbaci',
    customAttribute: 'Prilagođene značajke',
    checkOrAddCustomAttribute: 'Ovdje možete pregledavati i dodavati svoje prilagođene značajke.',
    attributeKey: 'Ključ značajke',
    attributeName: 'Naziv značajke',
    bot: 'Robot za razgovor',
    flow: 'Tijek',
    loadMore: 'Učitajte više',
    question: 'Pitanje',
    action: 'Akcija',
    search: 'Pretraživanje',
    selectBot: 'Odaberite robota za razgovor',
    selectFlow: 'Odaberite tijek',
    selectQuestion: 'Odaberite pitanje',
    noDataFoundHeading: 'Još uvijek niste stvorili nijednu prilagođenu značajku',
    noDataFoundSubheading: 'Sve vaše predložbe bit će prikazane ovdje',
    deleteTitle: 'Izbriši značajku',
    deleteDescription: 'Jeste li sigurni da želite izbrisati ovu prilagođenu značajku?',
    deleteAttributes: 'Izbriši značajke',
    areYouSureYouWantToDeleteThisAttributes: 'Jeste li sigurni da želite izbrisati ovu značajku?',
    editAttribute: 'Uredi značajku',
    headsUp: 'Pazi',
    okay: 'U redu',
    dataAddedToLead: 'Vaše API mapirane značajke neće biti ažurirane. Ažurirajte svoj API prema njima.',
    placeholders: {
      enterAttributeKey: 'Unesite ključ značajke',
      enterAttributeName: 'Unesite naziv značajke',
      selectBot: 'Odaberite robota za razgovor',
      selectFlow: 'Odaberite tijek',
      selectQuestion: 'Odaberite pitanje',
      search: 'Pretražite prema nazivu značajke'
    },
    appToolTip: {
      TOOLTIP_ATTRIBUTE_KEY: 'Unesite ključ značajke',
      TOOLTIP_ATTRIBUTE_NAME: 'Unesite naziv značajke',
      TOOLTIP_SELECT_BOT: 'Odaberite robota za razgovor',
      TOOLTIP_SELECT_FLOW: 'Odaberite tijek',
      TOOLTIP_SELECT_QUESTION: 'Odaberite pitanje',
    }
  },
  password: {
    changePassword: 'Promijeni lozinku',
    aSecurePasswordHelpsProtectYour: 'Sigurna lozinka pomaže u zaštiti vašeg',
    account: 'računa',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    cancel: 'Odustani',
    updatePassword: 'Ažuriraj lozinku',
    deleteAccount: 'Obriši račun',
    placeholders: {
      enterYourCurrentPassword: 'Unesite trenutnu lozinku',
      enterYourNewPassword: 'Unesite novu lozinku',
      enterYourConfirmPassword: 'Potvrdite novu lozinku'
    },
    appTooltip: {
      TOOLTIP_CURRENT_PASSWORD: 'Unesite trenutnu lozinku',
      TOOLTIP_NEW_PASSWORD: 'Unesite novu lozinku',
      TOOLTIP_CONFIRM_PASSWORD: 'Potvrdite novu lozinku',
      TOOLTIP_DELETE_ACCOUNT: `Obriši svoj ${brand} račun`,
    }
  },
  tags: {
    manageTags: 'Upravljanje oznakama',
    createNewTags: 'Stvori nove oznake',
    createNewTagsSubText: 'Upravljajte svojim oznakama kako biste bolje organizirali svoje vodiče, razgovore, grupe itd.',
    tagName: 'Naziv oznake',
    updateTag: 'Ažuriraj oznaku',
    createTag: 'Stvori oznaku',
    discard: 'Odbaci',
    searchTag: 'Pretraži oznaku po imenu',
    noTagFound: 'Nema pronađenih oznaka!',
    createATag: 'Stvori oznaku',
    deleteTagModalSubText: 'Jeste li sigurni da želite obrisati ovu oznaku? Ovo će također ukloniti oznaku iz svih povezanih korisnika!',
    deleteTagModalHeading: 'Obriši oznaku',
    deleteOneTagModalHeading: 'Obriši oznaku',
    actions: 'Radnje',
    placeholders: {
      enterTag: 'Unesite naziv oznake',
    },
    appTooltip: {
      TOOLTIP_DELETE_TAGS: 'Obriši oznake',
    }
  },
  thirdPartyIntegration: {
    list: {
      name: 'Ime',
      status: 'Status',
      action: 'Akcija',
      messageBird: 'MessageBird',
      messageBirdForSendingMessagesAndEmails: 'MessageBird za slanje poruka i e-pošte',
      notConnected: 'Nije povezano',
      connected: 'Povezano',
      edit: 'Uredi',
      plivo: 'Plivo',
      plivoForSendingMessages: 'Plivo za slanje poruka',
      connect: 'Poveži',
      appTooltip: {
        nameOfAppOrCrm: 'Naziv aplikacije/CRM-a',
        statusAsConnectedOrNotConnected: 'Povezano/Nije povezano',
        clickToConnectAppOrCrm: 'Kliknite za povezivanje s aplikacijom/CRM-om'
      },
      upgradeModal: {
        oopsIntegrationsAreNotAvailableForBabyPlan: 'Ups! Integracije nisu dostupne za Baby plan. Nadogradite se na King plan za integracije.',
      }
    },
    providers: {
      messageBird: {
        messageBird: 'MessageBird',
        integrateWithMessageBird: 'Integrirajte s MessageBird',
        apiKey: 'API ključ',
        originator: 'Pošiljatelj',
        connect: 'Poveži',
        disconnect: 'Isključi',
        seeActivities: 'Pogledajte aktivnosti',
        sms: 'SMS',
        time: 'Vrijeme',
        phoneNumber: 'Broj telefona',
        status: 'Status',
        botName: 'Ime robota',
        message: 'Poruka',
        error: 'Greška',
        placeholders: {
          apiKey: 'API ključ',
          messageBirdPhoneNumber: 'MessageBird broj telefona'
        },
        noDataFound: {
          activities: 'Aktivnosti',
          noActivitiesFound: 'Nema pronađenih aktivnosti!'
        }
      },
      plivo: {
        plivo: 'Plivo',
        integrateWithPlivo: 'Integrirajte s Plivo',
        authId: 'Auth ID',
        authToken: 'Auth token',
        yourPlivoPhoneNumber: 'Vaš Plivo broj telefona',
        connect: 'Poveži',
        disconnect: 'Isključi',
        seeActivities: 'Pogledajte aktivnosti',
        sms: 'SMS',
        time: 'Vrijeme',
        phoneNumber: 'Broj telefona',
        status: 'Status',
        botName: 'Ime robota',
        message: 'Poruka',
        error: 'Greška',
        noDataFound: {
          activities: 'Aktivnosti',
          noActivitiesFound: 'Nema pronađenih aktivnosti!'
        },
        placeholders: {
          authId: 'Auth ID',
          authToken: 'Auth token',
          yourPlivoPhoneNumber: 'Vaš Plivo broj telefona'
        }
      }
    }
  }

};

